import { InputAdornment, TextField } from '@mui/material';
import { useState, useEffect } from 'react';
import { debounce } from 'lodash';
import { Search } from '@mui/icons-material';

interface TableSearchbarProps {
  onSearch: (query: string) => void;
}

export default function TableSearchbar({ onSearch }: TableSearchbarProps) {
  const [searchTerm, setSearchTerm] = useState('');

  const debouncedSearch = debounce((value: string) => {
    if (value.length >= 3) {
      onSearch(value);
    } else {
      onSearch('');
    }
  }, 500);

  useEffect(() => {
    debouncedSearch(searchTerm);
    return () => {
      debouncedSearch.cancel();
    };
  }, [searchTerm]);

  return (
    <TextField
      variant="outlined"
      size="small"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      sx={{ flex: 5 }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search sx={{ color: 'textLight.main', fontSize: '18px' }} />
          </InputAdornment>
        ),
      }}
    />
  );
}
